import { isEmpty } from "../string";

// ORGNUMMER

const getOrgControlDigit = (controlDigit: number): number => {
  if (controlDigit % 11 === 0) return 0;
  const rest = controlDigit % 11;
  return 11 - rest;
};

export const organisasjonsnummer = (orgNr: string): boolean => {
  if (isEmpty(orgNr)) return false;
  if (orgNr.length !== 9) return false;
  const firstDigit = orgNr[0];
  if (firstDigit === "U" || firstDigit === "F") return true;
  if (firstDigit !== "8" && firstDigit !== "9") return false;
  const vektTall = [3, 2, 7, 6, 5, 4, 3, 2];
  let controlDigit = 0;
  vektTall.forEach((v, i) => {
    const intVal = parseInt(orgNr[i], 10);
    controlDigit += intVal * v;
  });
  controlDigit = getOrgControlDigit(controlDigit);
  return controlDigit === parseInt(orgNr[8], 10);
};

// KONTONUMMER

const getKontoControlDigit = (strValue: string): number => {
  return parseInt(strValue[strValue.length - 1], 10);
};

const getNumberWithoutControlDigit = (strValue: string): string => strValue.substr(0, strValue.length - 1);

const getCheckdigit = (strValue: string): number => {
  const weights = [2, 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7];
  let sum = 0;
  let weightIndex = 0;
  for (let numberIndex = strValue.length - 1; numberIndex >= 0; numberIndex -= 1, weightIndex += 1) {
    const digit = parseInt(strValue[numberIndex], 10);
    sum += digit * weights[weightIndex];
  }

  const remainder = sum % 11;
  if (remainder === 0) {
    return 0;
  }

  return 11 - remainder;
};

const mod11 = (strValue: string): boolean => {
  const asInt = parseInt(strValue, 10);
  if (Number.isNaN(asInt)) {
    return false;
  }

  const controlDigit = getKontoControlDigit(strValue);
  const checkDigit = getCheckdigit(getNumberWithoutControlDigit(strValue));
  return controlDigit === checkDigit;
};

export const kontonummer = (kontonr: string): boolean => {
  if (!kontonr || kontonr.length !== 11) {
    return false;
  }

  return mod11(kontonr);
};

// FØDELSNUMMER

const sumWithFactors = (fodselsnr: string, factors: Array<number>): number => {
  let sum = 0;
  for (let i = 0, l = factors.length; i < l; i += 1) {
    sum += parseInt(fodselsnr.charAt(i), 10) * factors[i];
  }
  return sum;
};

export const fodselsnummer = (fodselsnr: string): boolean => {
  if (isEmpty(fodselsnr) || fodselsnr.length !== 11) {
    return false;
  }

  let checksum1 = 11 - (sumWithFactors(fodselsnr, [3, 7, 6, 1, 8, 9, 4, 5, 2]) % 11);
  if (checksum1 === 11) checksum1 = 0;
  let checksum2 = 11 - (sumWithFactors(fodselsnr, [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]) % 11);
  if (checksum2 === 11) checksum2 = 0;
  return checksum1 === parseInt(fodselsnr.charAt(9), 10) && checksum2 === parseInt(fodselsnr.charAt(10), 10);
};
